module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "czewm-box"
  }, [_c('div', {
    staticClass: "czewm-content"
  }, [_c('img', {
    staticClass: "czewm-qrcode",
    attrs: {
      "src": require("../../../assets/image/ewm.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "czewm-label"
  }, [_vm._v("NB Chain " + _vm._s(_vm.$t('all.chongbidizhi')))]), _vm._v(" "), _c('div', {
    staticClass: "czewm-address"
  }, [_c('span', {
    staticClass: "czewm-address-text"
  }, [_vm._v("0x82...8F91")]), _vm._v(" "), _c('img', {
    staticClass: "czewm-address-copy",
    attrs: {
      "src": require("../../../assets/image/fuzhi_18@2x.png"),
      "alt": ""
    },
    on: {
      "click": _vm.handleCopy
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "czewm-btn-gradient",
    on: {
      "click": _vm.handleSaveQr
    }
  }, [_vm._v(_vm._s(_vm.$t('all.baocunerweima')))]), _vm._v(" "), _c('div', {
    staticClass: "czewm-btn",
    on: {
      "click": _vm.handleCopy
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fuzhidizhi')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fae70244"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/chongzhierweima/chongzhierweima.vue
// module id = 1007
// module chunks = 1